/**
 * Periscope tutorial illustrations: the layers and the motion vectors that place and move them.
 *
 * GENERATED by tools/periscope-render/gen_art.py (do not edit by hand). The corner scenes, the turn and the
 * objects are isometric SVG drawn with the Anatomy kit (tools/periscope-render/anatomy/build.mjs) from the real
 * periscope's cross-section ("Periscopio 6", Carpeta 02.glb), in flat Tracker palette colours with translucent
 * shadows; the camera -> mirror -> table section is a 2x WebP render. Every layer of a scene shares one
 * projection, so moving a piece in 3D is a plain 2D translate: the vectors below are those translations, in
 * CSS px of the 760x640 stage the coordinates are given in.
 */
import cornerTablet from '@/assets/periscope-tutorial/corner-tablet.svg';
import cornerPeriShadow from '@/assets/periscope-tutorial/corner-peri-shadow.svg';
import cornerPeri from '@/assets/periscope-tutorial/corner-peri.svg';
import cornerLiner from '@/assets/periscope-tutorial/corner-liner.svg';
import cornerMark0 from '@/assets/periscope-tutorial/corner-mark-0.svg';
import cornerMark1 from '@/assets/periscope-tutorial/corner-mark-1.svg';
import cornerMark2 from '@/assets/periscope-tutorial/corner-mark-2.svg';
import cornerPencil from '@/assets/periscope-tutorial/corner-pencil.svg';
import cornerCloth from '@/assets/periscope-tutorial/corner-cloth.svg';
import cornerPeriNopad from '@/assets/periscope-tutorial/corner-peri-nopad.svg';
import cornerTapePad from '@/assets/periscope-tutorial/corner-tape-pad.svg';
import cornerTapeRoll from '@/assets/periscope-tutorial/corner-tape-roll.svg';
import cornerFlipStrip from '@/assets/periscope-tutorial/corner-flip-strip.svg';
import cornerPeriTurn0 from '@/assets/periscope-tutorial/corner-peri-turn-0.svg';
import cornerPeriTurn1 from '@/assets/periscope-tutorial/corner-peri-turn-1.svg';
import cornerPeriTurn2 from '@/assets/periscope-tutorial/corner-peri-turn-2.svg';
import cornerPeriTurn3 from '@/assets/periscope-tutorial/corner-peri-turn-3.svg';
import cornerPeriTurn4 from '@/assets/periscope-tutorial/corner-peri-turn-4.svg';
import cornerPeriTurn5 from '@/assets/periscope-tutorial/corner-peri-turn-5.svg';
import cornerPeriTurn6 from '@/assets/periscope-tutorial/corner-peri-turn-6.svg';
import cornerPeriTurn7 from '@/assets/periscope-tutorial/corner-peri-turn-7.svg';
import cornerPeriTurn8 from '@/assets/periscope-tutorial/corner-peri-turn-8.svg';
import cornerPeriTurn9 from '@/assets/periscope-tutorial/corner-peri-turn-9.svg';
import cornerPeriTurn10 from '@/assets/periscope-tutorial/corner-peri-turn-10.svg';
import cornerPeriTurn11 from '@/assets/periscope-tutorial/corner-peri-turn-11.svg';
import cornerFlip0 from '@/assets/periscope-tutorial/corner-flip-0.svg';
import cornerFlip1 from '@/assets/periscope-tutorial/corner-flip-1.svg';
import cornerFlip2 from '@/assets/periscope-tutorial/corner-flip-2.svg';
import cornerFlip3 from '@/assets/periscope-tutorial/corner-flip-3.svg';
import cornerFlip4 from '@/assets/periscope-tutorial/corner-flip-4.svg';
import cornerFlip0Tape from '@/assets/periscope-tutorial/corner-flip-0-tape.svg';
import cornerFlip1Tape from '@/assets/periscope-tutorial/corner-flip-1-tape.svg';
import cornerFlip2Tape from '@/assets/periscope-tutorial/corner-flip-2-tape.svg';
import cornerFlip3Tape from '@/assets/periscope-tutorial/corner-flip-3-tape.svg';
import cornerFlip4Tape from '@/assets/periscope-tutorial/corner-flip-4-tape.svg';
import needPeri from '@/assets/periscope-tutorial/need-peri.svg';
import needBottle from '@/assets/periscope-tutorial/need-bottle.svg';
import needCloth from '@/assets/periscope-tutorial/need-cloth.svg';
import needPencil from '@/assets/periscope-tutorial/need-pencil.svg';
import sideTable from '@/assets/periscope-tutorial/side-table.webp';
import sideTablet from '@/assets/periscope-tutorial/side-tablet.webp';
import sidePeriFull from '@/assets/periscope-tutorial/side-peri-full.webp';
import sidePeri from '@/assets/periscope-tutorial/side-peri.webp';
import exampleBadBottom from '@/assets/periscope-tutorial/mal-abajo.webp';
import exampleBadTop from '@/assets/periscope-tutorial/mal-arriba.webp';

/** The stage every coordinate below is measured in (CSS px). Scale the whole stage to fit, never a layer. */
export const STAGE = Object.freeze({ width: 760, height: 640 });

/** Each layer's box on the stage. */
export const LAYERS = Object.freeze({
  cornerTablet: { src: cornerTablet, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriShadow: { src: cornerPeriShadow, x: 0, y: 0, w: 760, h: 640 },
  cornerPeri: { src: cornerPeri, x: 0, y: 0, w: 760, h: 640 },
  cornerLiner: { src: cornerLiner, x: 0, y: 0, w: 760, h: 640 },
  cornerMark0: { src: cornerMark0, x: 0, y: 0, w: 760, h: 640 },
  cornerMark1: { src: cornerMark1, x: 0, y: 0, w: 760, h: 640 },
  cornerMark2: { src: cornerMark2, x: 0, y: 0, w: 760, h: 640 },
  cornerPencil: { src: cornerPencil, x: 0, y: 0, w: 760, h: 640 },
  cornerCloth: { src: cornerCloth, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriNopad: { src: cornerPeriNopad, x: 0, y: 0, w: 760, h: 640 },
  cornerTapePad: { src: cornerTapePad, x: 0, y: 0, w: 760, h: 640 },
  cornerTapeRoll: { src: cornerTapeRoll, x: 0, y: 0, w: 760, h: 640 },
  cornerFlipStrip: { src: cornerFlipStrip, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn0: { src: cornerPeriTurn0, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn1: { src: cornerPeriTurn1, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn2: { src: cornerPeriTurn2, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn3: { src: cornerPeriTurn3, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn4: { src: cornerPeriTurn4, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn5: { src: cornerPeriTurn5, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn6: { src: cornerPeriTurn6, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn7: { src: cornerPeriTurn7, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn8: { src: cornerPeriTurn8, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn9: { src: cornerPeriTurn9, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn10: { src: cornerPeriTurn10, x: 0, y: 0, w: 760, h: 640 },
  cornerPeriTurn11: { src: cornerPeriTurn11, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip0: { src: cornerFlip0, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip1: { src: cornerFlip1, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip2: { src: cornerFlip2, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip3: { src: cornerFlip3, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip4: { src: cornerFlip4, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip0Tape: { src: cornerFlip0Tape, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip1Tape: { src: cornerFlip1Tape, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip2Tape: { src: cornerFlip2Tape, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip3Tape: { src: cornerFlip3Tape, x: 0, y: 0, w: 760, h: 640 },
  cornerFlip4Tape: { src: cornerFlip4Tape, x: 0, y: 0, w: 760, h: 640 },
  needPeri: { src: needPeri, x: 0, y: 0, w: 600, h: 420 },
  needBottle: { src: needBottle, x: 0, y: 0, w: 420, h: 600 },
  needCloth: { src: needCloth, x: 0, y: 0, w: 600, h: 420 },
  needPencil: { src: needPencil, x: 0, y: 0, w: 600, h: 300 },
  sideTable: { src: sideTable, x: 0.0, y: 449.0, w: 760.0, h: 191.0 },
  sideTablet: { src: sideTablet, x: 524.5, y: 0.0, w: 61.5, h: 216.0 },
  sidePeriFull: { src: sidePeriFull, x: 371.0, y: 40.5, w: 175.0, h: 162.5 },
  sidePeri: { src: sidePeri, x: 371.0, y: 40.5, w: 174.5, h: 135.0 },
});

/** Translations on the 3/4 corner view (CSS px). */
export const MOTION = Object.freeze({
  /** The periscope lifted 40 mm / 30 mm off the tablet. */
  lift40: [0.0, -205.6],
  lift30: [0.0, -154.2],
  /** Where the red pad slides to as it is peeled off. */
  peel: [167.1, -243.9],
  /** The cloth's wipe, around the camera (closed loop). */
  wipe: [[40.3, -24.8], [18.7, 12.7], [-55.2, 14.7], [-22.4, -15.2], [40.3, -24.8]],
  /** The pencil tip's path round the base (side, back, side), relative to where the pencil layer sits. */
  pencil: [[0.0, 0.0], [-85.1, -57.7], [-226.4, 0.8], [-141.4, 58.5]],
  /** From the new tape strip's place under the base to the roll it is cut from (re-taping step). */
  tapeFrom: [-428.5, -64.5],
  /** Re-taping: the lifted, turned-over periscope comes down by this much to land on the tablet. */
  flipDrop: [0, 185.0],
  /** Re-taping: from the new strip's place on the upturned base back to the roll it is cut from. */
  flipStripFrom: [-428.5, 282.9],
  /** Where to push (top of the base). */
  press: [546.9, 283.8],
  /** The periscope's centre on the stage — what the framing below centres. */
  periscopeCenter: [419.0, 353.3],
});

/**
 * How each corner scene is framed: the periscope centre lands on `center`, the stage scaled by `scale`. A scene
 * moved off the periscope centre is scaled just enough to keep the tablet covering the box (`fill` in gen_art.py);
 * place and unstick are zoomed out on purpose, the whole corner floating on the background.
 */
export const FRAMING = Object.freeze({
  welcome: { center: [419.0, 353.3], scale: 1 },
  clean: { center: [419.0, 353.3], scale: 1 },
  place: { center: [300, 190], scale: 0.82 },
  mark: { center: [419.0, 353.3], scale: 1 },
  stick: { center: [419.0, 368.3], scale: 1.043 },
  done: { center: [419.0, 353.3], scale: 1 },
  unstick: { center: [399.0, 383.3], scale: 0.78 },
  retape: { center: [439.0, 363.3], scale: 1.048 },
});

/** The side section (camera -> mirror -> table): the light path and where its three labels go. */
export const SECTION = Object.freeze({
  ray: [[527.0, 130.2], [428.8, 130.2], [363.7, 450.2]],
  labels: { camera: [600, 104], mirror: [292, -2], table: [452, 384] },
  /** The inset shows the section at this scale, shifted by `offset`. */
  scale: 0.5,
  offset: [-100, 0],
});

/** The periscope turned on itself, one full turn in 30° frames, for the "unstick it by turning it" step. */
export const TURN_FRAMES = Object.freeze([LAYERS.cornerPeriTurn0, LAYERS.cornerPeriTurn1, LAYERS.cornerPeriTurn2, LAYERS.cornerPeriTurn3, LAYERS.cornerPeriTurn4, LAYERS.cornerPeriTurn5, LAYERS.cornerPeriTurn6, LAYERS.cornerPeriTurn7, LAYERS.cornerPeriTurn8, LAYERS.cornerPeriTurn9, LAYERS.cornerPeriTurn10, LAYERS.cornerPeriTurn11]);

/**
 * Re-taping: the periscope lifted and turned over about its long axis, 0° (upright) to 180° (base up) in five
 * frames, without its tape and with the new tape on the base.
 */
export const FLIP_FRAMES = Object.freeze([LAYERS.cornerFlip0, LAYERS.cornerFlip1, LAYERS.cornerFlip2, LAYERS.cornerFlip3, LAYERS.cornerFlip4]);
export const FLIP_FRAMES_TAPED = Object.freeze([LAYERS.cornerFlip0Tape, LAYERS.cornerFlip1Tape, LAYERS.cornerFlip2Tape, LAYERS.cornerFlip3Tape, LAYERS.cornerFlip4Tape]);

/** Real captures of a badly placed periscope (brand marks and printed text removed). */
export const EXAMPLES = Object.freeze({
  badBottom: exampleBadBottom,
  badTop: exampleBadTop,
});
